import { useEffect, useState } from "react";
import { useProjects } from "../features/projectOverview/mutation";

export const useProjectTitle = (projectId?: string) => {
  const [projectTitle, setProjectTitle] = useState<string | undefined>(undefined);
  const fetchProjectDetails = useProjects();

  useEffect(() => {
    if (projectId) {
      const fetchData = async () => {
        try {
          const response = await fetchProjectDetails.mutateAsync(projectId);
          const title = response?.data?.data?.panel_details?.title;
          setProjectTitle(title);
        } catch (error) {
          console.error("Error fetching project title:", error);
          setProjectTitle(undefined);
        }
      };

      fetchData();
    } else {
      setProjectTitle(undefined);
    }
  }, [projectId]);

  return { projectTitle, isLoading: false };
};

